export default "__VITE_ASSET__CzA7vt5___"